import { Divider } from 'antd'
import React, { FunctionComponent, memo } from 'react'

export interface FinancingHelpSectionProps {
  divider?: string
  title?: React.ReactNode
  children?: React.ReactNode
  isLast?: boolean
  highlightId?: string
}

export const FinancingHelpSection: FunctionComponent<FinancingHelpSectionProps> =
  memo(props => {
    return (
      <div>
        {props.divider && (
          <Divider
            orientation="left"
            orientationMargin={0}
            plain
            className="!text-gray-400"
          >
            {props.divider}
          </Divider>
        )}
        <div className={`flex space-x-2 ${props.isLast ? '' : 'mb-1'}`}>
          {props.title && (
            <div
              className={`w-36 font-semibold outline-white outline-2 transition-all ${
                props.highlightId || ''
              }`}
            >
              {props.title}
            </div>
          )}
          <div className="flex-1">{props.children}</div>
        </div>
      </div>
    )
  })
